module.exports = __webpack_public_path__ + "img/13.742272a3.jpg";